<template>
    <v-expansion-panels v-model="localExpanded">
        <v-expansion-panel>
            <template v-slot:title>
                <v-row no-gutters class="container">
                    <v-col cols="6" class="text-center">
                        {{ getPatientName }}
                    </v-col>
                    <v-col cols="6" class="text-center divider-class">
                        {{ getPatientBirthdate }}
                    </v-col>
                </v-row>
            </template>
            <v-expansion-panel-text class="bg-aqua-teal">
                <div class="d-flex justify-center mb-2">
                    <h1>{{ getPatientName }}</h1>
                </div>
                <div :class="`${justifyProgressChartButtons} mb-2`">
                    <v-btn color="#ff6d44" outlined @click="goToPatientProgress(getPatientId)">See Progress</v-btn>
                </div>
                <v-expansion-panels>

                    <!-- Patient Treatment Plan -->
                    <patient-plan-sub-panel :plan="getPlan" :patient-id="getPatientId" :provider-id="getProvider"
                        :plans-list="plansList" @delete-plan="removePlan" @finished-plan="fetchTherapyPlan"
                        @build-plan="buildPlan"></patient-plan-sub-panel>


                    <!-- Patient Diagnosis -->
                    <patient-sub-panel header="Diagnosis" title="Diagnosis" :text="getDiagnosis" update-key="diagnosis"
                        @update-patient-data="updatePatientData" />

                    <!-- Patient Notes -->
                    <patient-sub-panel header="Notes" title="Notes" :text="getNotes" update-key="notes"
                        @update-patient-data="updatePatientData" />

                    <!-- Patient Summary -->
                    <patient-sub-panel header="Summary" title="Summary" :text="getSummary" update-key="summary"
                        @update-patient-data="updatePatientData" />

                </v-expansion-panels>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import axios from 'axios';
import PatientSubPanel from './PatientSubPanel.vue';
import PatientPlanSubPanel from './PatientPlanSubPanel.vue';
export default {
    name: "PatientPanel",
    data: () => ({
        date: null,
        name: "Niki Fowler",
        plan: null,
        plansList: [],
        open: false,
        patientDiagnoses: [],
        patientNotes: [],
        patientSummary: null,
        localPatient: null,
        isLoadingData: false,
        localExpanded: []
    }),
    watch: {
    forceExpanded(newVal) {
      this.localExpanded = newVal ? [0] : [];
     }
    },
    components: {
        PatientSubPanel,
        PatientPlanSubPanel
    },
    emits: ['buildPlan'],
    props: {
    patient: Object,
    forceExpanded: Boolean,
  },
    methods: {
        dummy() {
            alert("Clicked");
        },
        removePlan(planId) {
            if (this.plansList.length > 0) {
                this.plansList = this.plansList.filter(plan => plan.planId !== planId);
            }
        },
        buildPlan(queryObj){
            this.$emit('buildPlan', queryObj);
        },
        async fetchTherapyPlan() {
            axios.defaults.baseURL = process.env.VUE_APP_API_URL;
            try {
                const response = await axios.get(`/api/therapyplan/patient/${this.patient.encryptedPatientId}`);
                this.plan = response.data;
            } catch (error) {
                console.log(error);
            }

            try {
                const response = await axios.get(`/api/therapyplan/patient/${this.patient.encryptedPatientId}/all`);
                this.plansList = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async updatePatientData(updatedData) {
            console.log("Inside Update Patient Data", updatedData);
            const key = updatedData["key"];
            const value = updatedData["value"];

            if (!this.patient || !this.patient.encryptedPatientId) return;

            axios.defaults.baseURL = process.env.VUE_APP_API_URL;

            try {
                // Handle different update types based on the key
                if (key === "diagnosis") {
                    // Update diagnosis
                    if (this.patientDiagnoses && this.patientDiagnoses.length > 0) {
                        // Update the most recent diagnosis
                        const latestDiagnosis = [...this.patientDiagnoses]
                            .sort((a, b) => new Date(b.diagnosisDate) - new Date(a.diagnosisDate))[0];

                        // Create updated diagnosis object
                        const updatedDiagnosis = {
                            ...latestDiagnosis,
                            diagnosisText: value,
                            updateDate: new Date().toISOString()
                        };

                        // Send update request
                        await axios.put(
                            `/api/Patientdiagnosis/update-patient-diagnosis/${latestDiagnosis.patientDiagnosisId}/${this.patient.encryptedPatientId}`,
                            updatedDiagnosis
                        );

                        // Refresh diagnoses
                        await this.fetchPatientDiagnoses();
                    } else {
                        // Create new diagnosis if none exists
                        const newDiagnosis = {
                            diagnosisText: value,
                            diagnosisDate: new Date().toISOString()
                        };

                        await axios.post(
                            `/api/Patientdiagnosis/add-patient-diagnosis/${this.patient.encryptedPatientId}`,
                            newDiagnosis
                        );

                        // Refresh diagnoses
                        await this.fetchPatientDiagnoses();
                    }
                } else if (key === "notes") {
                    // Update notes
                    if (this.patientNotes && this.patientNotes.length > 0) {
                        // Update the most recent note
                        const latestNote = [...this.patientNotes]
                            .sort((a, b) => new Date(b.noteDate) - new Date(a.noteDate))[0];

                        // Create updated note object
                        const updatedNote = {
                            ...latestNote,
                            noteText: value,
                            updateDate: new Date().toISOString()
                        };

                        // Send update request
                        await axios.put(
                            `/api/Patientnote/update-patient-note/${latestNote.patientNoteId}/${this.patient.encryptedPatientId}`,
                            updatedNote
                        );

                        // Refresh notes
                        await this.fetchPatientNotes();
                    } else {
                        // Create new note if none exists
                        const newNote = {
                            noteText: value,
                            noteDate: new Date().toISOString()
                        };

                        await axios.post(
                            `/api/Patientnote/add-patient-note/${this.patient.encryptedPatientId}`,
                            newNote
                        );

                        // Refresh notes
                        await this.fetchPatientNotes();
                    }
                } else if (key === "summary") {
                    // Summary might be generated dynamically, so update the patient record directly
                    let updatedPatient = JSON.parse(JSON.stringify(this.patient));
                    updatedPatient.summary = value;

                    await axios.put(
                        `/api/patient/update-patient/${updatedPatient.encryptedPatientId}/${updatedPatient.encryptedProviderId}/${updatedPatient.encryptedUserId}`,
                        updatedPatient
                    );

                    // Refresh summary
                    await this.fetchPatientSummary();
                } else if (this.patient && Object.hasOwn(this.patient, key)) {
                    // Handle other patient fields directly
                    let updatedPatient = JSON.parse(JSON.stringify(this.patient));
                    updatedPatient[key] = value;

                    await axios.put(
                        `/api/patient/update-patient/${updatedPatient.encryptedPatientId}/${updatedPatient.encryptedProviderId}/${updatedPatient.encryptedUserId}`,
                        updatedPatient
                    );

                    // Update local data instead of the prop
                    if (this.localPatient) {
                        this.localPatient[key] = value;
                    }
                }
            } catch (error) {
                console.error("Error updating data:", error);
            }
        },
        goToPatientProgress(pid) {
            this.$router.push({ name: 'MyProgress', query: { patientId: pid, isProviderView: "true" } });
        },
        async fetchPatientDiagnoses() {
            console.log("fetchPatientDiagnoses called");
            if (!this.patient || !this.patient.encryptedPatientId) {
                console.log("No patient ID available", this.patient);
                return;
            }

            console.log("Patient ID:", this.patient.encryptedPatientId);
            this.isLoadingData = true;
            axios.defaults.baseURL = process.env.VUE_APP_API_URL;
            try {
                console.log("About to fetch from:", `${process.env.VUE_APP_API_URL}/api/Patientdiagnosis/patient/${this.patient.encryptedPatientId}`);
                const response = await axios.get(`/api/Patientdiagnosis/patient/${this.patient.encryptedPatientId}`);
                console.log("Patient diagnoses response:", response.data);

                if (response.data) {
                    this.patientDiagnoses = response.data;
                    console.log("patientDiagnoses after assignment:", this.patientDiagnoses);
                    console.log("patientDiagnoses length:", this.patientDiagnoses.length);
                }
            } catch (error) {
                console.error("Error fetching patient diagnoses:", error);
            } finally {
                this.isLoadingData = false;
            }
        },
        async fetchPatientNotes() {
            if (!this.patient || !this.patient.encryptedPatientId) return;

            this.isLoadingData = true;
            axios.defaults.baseURL = process.env.VUE_APP_API_URL;
            try {
                // Get notes directly for this patient
                const response = await axios.get(`/api/Patientnote/patient/${this.patient.encryptedPatientId}`);
                if (response.data) {
                    this.patientNotes = response.data;
                }
            } catch (error) {
                console.error("Error fetching patient notes:", error);
            } finally {
                this.isLoadingData = false;
            }
        },
        async fetchPatientSummary() {
            if (!this.patient || !this.patient.encryptedPatientId) return;

            this.isLoadingData = true;
            axios.defaults.baseURL = process.env.VUE_APP_API_URL;
            try {
                const response = await axios.get(
                    `/api/Patient/my-progress-overview/${this.patient.encryptedPatientId}?isProvider=true`
                );
                if (response.data) {
                    this.patientSummary = response.data.summary;
                }
            } catch (error) {
                console.error("Error fetching patient summary:", error);
            } finally {
                this.isLoadingData = false;
            }
        },
        async fetchAllPatientData() {
            // Call all fetch methods at once
            await Promise.all([
                this.fetchPatientDiagnoses(),
                this.fetchPatientNotes(),
                this.fetchPatientSummary()
            ]);
        }
    },
    computed: {
        /** The following computed components handle 
         * undefined fields for displaying patient 
         * information.
         */
        getDiagnosis() {
            if (this.patientDiagnoses && this.patientDiagnoses.length > 0) {
                // Create a copy and sort by diagnosisDate
                const latestDiagnosis = [...this.patientDiagnoses]
                    .sort((a, b) => new Date(b.diagnosisDate) - new Date(a.diagnosisDate))[0];
                return latestDiagnosis.diagnosisText; // Use diagnosisText not content
            }
            return "No diagnosis available.";
        },
        getNotes() {
            console.log("getNotes called, patientNotes:", this.patientNotes);
            if (this.patientNotes && this.patientNotes.length > 0) {
                // Get the most recent note
                const latestNote = [...this.patientNotes]
                    .sort((a, b) => new Date(b.noteDate) - new Date(a.noteDate))[0];
                console.log("Latest note:", latestNote);
                return latestNote.noteText;  // Make sure this matches the API field name
            }
            return "No notes available.";
        },
        getSummary() {
            if (this.patientSummary) {
                return this.patientSummary;
            }
            return "No summary available.";
        },
        getPatientName() {
            if (this.patient) {
                return `${this.patient.firstName} ${this.patient.lastName}`;
            }
            return "Name unavailable";
        },
        getPlan() {
            return this.plan;
        },
        getProvider() {
            return this.patient.encryptedProviderId;
        },
        getPatientId() {
            return this.patient.encryptedPatientId;
        },
        /* The following methods involve headers being used to
        indicate whether a patient has a diagnosis or treatment plan. */
        getTreatmentPlanIndicator() {
            if (this.plan) {
                return "Has Treatment Plan";
            }
            return "No Treatment Plan";

        },
        getDiagnosisIndicator() {
            if (this.patientDiagnoses && this.patientDiagnoses.length > 0) {
                return "Has Diagnosis";
            }
            return "No Diagnosis";
        },
        getPatientBirthdate(){
            let dob = this.patient.dateOfBirth;
            return (dob) ? new Date(dob).toLocaleDateString('es-pa') : "DOB Unavailable";
        }, 
        justifyProgressChartButtons() {
            let prefix = "d-flex"
            switch (this.$vuetify.display.name) {
                case "md", "lg": return `${prefix} justify-end`;
            }
            return `${prefix} justify-center`;
        },
    },
    mounted() {
        if (this.patient) {
            this.localPatient = JSON.parse(JSON.stringify(this.patient));
        }
        this.fetchTherapyPlan();
        this.fetchAllPatientData();
    }
}
</script>

<style>
.bg-aqua-teal {
    background-color: #08b6aa;
}

.bg-bright-orange {
    background-color: #ff6d44;
}

.bg-white {
    background-color: white;
}

.divider-class {
    border-left-style: solid;
}

.container {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

}

.container-right {
    display: flex;
    justify-content: end;
    align-items: center;
}
</style>
